import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { exportExcel } from "../hooks/useExportUtils";
import { ListBox } from "primereact/listbox";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import Bajas from "../components/Bajas";
import { Dialog } from 'primereact/dialog';
        
export const BajasTranferencia = ({ Auth }) => {
  const dt = useRef(null);
  const toast = useRef(null);
  const { selectedNomina } = useOutletContext();
  const [listadoFaltas, setListadoFaltas] = useState([]);
  const [nominas, setNominas] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [periodosDisponibles, setPeriodosDisponibles] = useState([]);
  const [periodoSeleccionado, setPeriodoSeleccionado] = useState(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const periodoParam = queryParams.get("periodo");
    if (periodoParam) {
      setPeriodoSeleccionado(periodoParam);
    }
  }, [location.search]);

  const getData = async () => {
    try {
        const response = await axiosPrivate.get(
        `NOM/baja-empleados?nomina=${selectedNomina.idNomina}`
      );
      const data = response.data;
      console.log("Datos de bajas:", data);
      setListadoFaltas(data);

      const resNominas = await axiosPrivate.get("NOM/nominas");
      setNominas(resNominas.data);
      const resPeriodos = await axiosPrivate.get("NOM/bonos/periodos");
      setPeriodosDisponibles(resPeriodos.data);
    } catch (error) {
      console.error("Error al obtener la baja:", error);
    }
  };

  useEffect(() => {
    if (!selectedNomina) return;
    getData();
  }, [selectedNomina]);
  const columns = [
    
    { field: "numero", header: "Número", sortable: true },
    { field: "nombre", header: "Nombre", sortable: true },
    { field: "periodo", header: "Periodo", sortable: true },
    { field: "fechaBaja", header: "Fecha de baja", sortable: true },
    { field: "tipoBaja", header: "Tipo de falta", sortable: true },
    { field: "created_at", header: "Fecha de captura", sortable: true },
    { field: "usuario", header: "Usuario", sortable: true },
    
  ];

  const formatFecha = (valor) => {
    if (!valor) return "";
    const fecha = new Date(valor);
    if (isNaN(fecha)) return "";

    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const año = fecha.getFullYear();

    return `${dia}/${mes}/${año}`;
  };
  const dynamicColumns = columns.map((col) => {
    const camposFecha = [
      "created_at",
      "updated_at",
      "fechas",
      "fechaIngreso",
      "fechaBaja",
    ];
    return (
      <Column
        key={col.field}
        field={col.field}
        header={col.header}
        sortable={col.sortable}
        body={
          camposFecha.includes(col.field)
            ? (rowData) => {
                const valor = rowData[col.field];
                if (Array.isArray(valor)) {
                  return valor.map((f) => formatFecha(f)).join(", ");
                }
                return formatFecha(valor);
              }
            : undefined
        }
      />
    );
  });
  const template2 = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
      ];

      return (
        <>
          <span className="mx-2">Items por página:</span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </>
      );
    },
    CurrentPageReport: (options) => (
      <span className="mx-2">
        {options.first} - {options.last} de {options.totalRecords}
      </span>
    ),
  };

  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  };
  const handleBack = () => {
    navigate(-1);
  };

  const [seleccionados, setSeleccionados] = useState([]);

  const leftToolbarTemplate = () => (
    <div className="flex gap-2 items-center flex-center">
      <label htmlFor="periodo" className="whitespace-nowrap">
        Filtrar por periodo:
      </label>
      <Dropdown
        id="periodo"
        value={periodoSeleccionado}
        options={periodosDisponibles}
        onChange={(e) => setPeriodoSeleccionado(e.value)}
        placeholder="Selecciona periodo"
        className="w-15rem"
        showClear
      />
      {/* <label htmlFor="periodo" className="whitespace-nowrap">
        Seleccione la nomina:
      </label>
      <ListBox
        value={seleccionados}
        options={nominas}
        id="nominas"
        onChange={(e) => setSeleccionados(e.value)}
        multiple
        optionLabel="Nomina"
        optionValue="idNomina"
        metaKeySelection={true}
        checkbox={"checkbox"}
        style={{ width: "20rem" }}
        listStyle={{ maxHeight: "150px" }}
      /> */}
      {/* <Button
        label="Cargar registros"
        icon="pi pi-refresh"
        severity="secondary"
        onClick={() => CargarRegistros(seleccionados, periodoSeleccionado)}
      /> */}
    </div>
  );
  const CargarRegistros = (data, periodo) => {
    if (!data || data.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Advertencia",
        detail: "Debe seleccionar al menos una nómina",
        life: 3000,
      });
      return;
    }
    if (!periodo) {
      toast.current.show({
        severity: "warn",
        summary: "Advertencia",
        detail: "Debe seleccionar un periodo",
        life: 3000,
      });
      return;
    }
    axiosPrivate
      .post(`/NOM/bonos/procesar`, {
        nominaIds: data,
        periodo: periodo,
      })
      .then((response) => {
        console.log("Transferencia response:", response.data);
        setListadoFaltas(response.data);
        toast.current.show({
          severity: "success",
          summary: "Éxito",
          detail: response.data.msg,
          life: 3000,
        });
        getData();
      })
      .catch((error) => {
        setListadoFaltas([]);
        console.error("Error al transferir la baja:", error);
        toast.current?.show({
          severity: "warn",
          summary: "Sin resultados",
          detail:
            "No se encontraron registros.",
          life: 3000,
        });
      });
  };

  const TransferirFaltas = () => {
    if (listadoFaltas.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Advertencia",
        detail: "No hay registros para transferir",
        life: 3000,
      });
      return;
    }
    console.log("Transferir bajas:", listadoFaltas);
    confirmDialog({
      message: "¿Está seguro de aplicar la baja seleccionadas?",
      header: "Confirmación",
      icon: "pi pi-question-circle",
      accept: async () => {
        try {
          //const excepcionIds = listadoFaltas.map((item) => item._id);
          const response = await axiosPrivate.post(`/NOM/bonos/transferir`, {
            registros:listadoFaltas,
            periodo: `${selectedNomina.YearPeriodo}-${selectedNomina.PeriodoActual.toString().padStart(2, "0")}`, // o como esté tu periodo
          });
          console.log("Transferencia response:", response.data);
          toast.current.show({
            severity: "success",
            summary: "Éxito",
            detail: response.data.msg,
            life: 3000,
          });
        } catch (error) {
          console.error("Error al transferir baja:", error);
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "No se pudo aplicar la baja",
            life: 3000,
          });
        }
      },
    });
  };

  const removeRegistro = (excepcion) => {
    confirmDialog({
      message: `¿Estás seguro de quitar el registro de "${excepcion.Nombre}"?`,
      header: "Confirmar remoción",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí, eliminar",
      rejectLabel: "Cancelar",
      accept: async () => {
        try {
          const nuevosDatos = listadoFaltas.filter(
            (d) => d._id !== excepcion._id
          );
          setListadoFaltas(nuevosDatos);
        } catch (error) {
          console.error("Error al eliminar:", error);
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "No se pudo eliminar el empleado",
            life: 3000,
          });
        }
      },
    });
  };
const [bajaSeleccionada, setBajaSeleccionada] = useState(null);
const [mostrarModal, setMostrarModal] = useState(false);
const cargarListado = async () => {
  const res = await axiosPrivate.get(`/NOM/baja-empleados?nomina=${selectedNomina.idNomina}`);
  setListadoFaltas(res.data);
};

const handleAplicado = async () => {
  setMostrarModal(false); // ⬅️ cierra el modal
  await cargarListado();  // ⬅️ recarga el DataTable
};
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        <Button
        icon="pi pi-eye"
        className="p-button-text p-button-sm"
        tooltip="Ver Detalles"
        onClick={() => {
          setBajaSeleccionada(rowData);
          setMostrarModal(true);
        }}
      />
        <Button
          icon="pi pi-minus-circle"
          className="p-button-rounded p-button-warning p-button-sm"
          onClick={() => removeRegistro(rowData)}
          tooltip="Remover registro"
        />
      </div>
    );
  };
  return (
    <div className="p-m-4">
      <Toast ref={toast} />
      <ConfirmDialog />
      <Card title="Solicitudes de bajas">
        <div className="mb-3 flex justify-content-between">
          <Button
            label="Regresar"
            icon="pi pi-arrow-left"
            className="p-button-secondary"
            onClick={handleBack}
          />
          <Button
            label="Exportar Excel"
            icon="pi pi-file-excel"
            severity="success"
            onClick={() => exportExcel(listadoFaltas, "Faltas")}
          />
          {/* <Button
            label="Transferir faltas"
            icon="pi pi-cog"
            className="p-button-info"
            onClick={() => TransferirFaltas()}
          /> */}
        </div>
        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
        />
        <DataTable
          ref={dt}
          value={listadoFaltas}
          paginator
          paginatorTemplate={template2}
          first={first2}
          rows={rows2}
          onPage={onCustomPage2}
          removableSort
          className="p-datatable-sm"
          stripedRows
          globalFilter={globalFilter}
          globalFilterFields={[
            "numero",
            "Nombre",
            "fechas",
            "periodo",
            "usuario",
          ]}
        >
          {dynamicColumns}
          <Column
            body={actionBodyTemplate}
            header="Acciones"
            style={{ minWidth: "10rem" }}
          />
        </DataTable>
      </Card>
      
<Dialog
  header="Aplicar baja"
  visible={mostrarModal}
  style={{ width: "60vw" }}
  modal
  onHide={() => setMostrarModal(false)}
>
  {bajaSeleccionada && (
    <Bajas
      modo="aplicar"
      idRegistro={bajaSeleccionada._id}
      selectedNomina={selectedNomina}
       onAplicado={handleAplicado}
    />
  )}
</Dialog>

    </div>
  );
};

export default BajasTranferencia;
